import gnb from './gnb'
import orgmap from './orgmap'
import common from './common'
import sms from './sms'
import kyobobook from './kyobobook'

export default {
    gnb,
    orgmap,
    common,
    sms,
    kyobobook
}